import Vue from 'vue';
import {
  ADD_CLIENT_REQUEST,
  ADD_CLIENT_SUCCESS,
  ADD_CLIENT_ERROR,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  ADD_USER_ERROR,
  GET_CLIENTS_REQUEST,
  GET_CLIENTS_SUCCESS,
  GET_CLIENTS_ERROR,
  GET_CLIENT_REQUEST,
  GET_CLIENT_SUCCESS,
  GET_CLIENT_ERROR,
  GET_CLIENT_USERS_REQUEST,
  GET_CLIENT_USERS_SUCCESS,
  GET_CLIENT_USERS_ERROR,
  PUT_CLIENT_REQUEST,
  PUT_CLIENT_SUCCESS,
  PUT_CLIENT_ERROR,
  PUT_USER_REQUEST,
  PUT_USER_SUCCESS,
  PUT_USER_ERROR,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR
} from './actionTypes';
import clientApi from '../../_api/client';

const state = {
  clients: {},
  client: {},
  brands: [],
  status: '',
  user: {},
  errors: [],
  hasLoadedOnce: false
};

const getters = {
  clients: (state) => state.clients
};

const actions = {
  [ADD_CLIENT_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADD_CLIENT_REQUEST);
      clientApi
        .addClient(payload)
        .then((response) => {
          commit(ADD_CLIENT_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(ADD_CLIENT_ERROR, error);
          reject(error);
        });
    });
  },
  [ADD_USER_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADD_USER_REQUEST);
      clientApi
        .addUser(payload)
        .then((response) => {
          commit(ADD_USER_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(ADD_USER_ERROR, error);
          reject(error);
        });
    });
  },

  [GET_CLIENTS_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_CLIENTS_REQUEST);
      clientApi
        .getClients()
        .then((response) => {
          commit(GET_CLIENTS_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(GET_CLIENTS_ERROR, error);
          reject(error);
        });
    });
  },
  [GET_CLIENT_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_CLIENT_REQUEST);
      clientApi
        .getClient(payload)
        .then((response) => {
          commit(GET_CLIENT_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(GET_CLIENT_ERROR, error);
          reject(error);
        });
    });
  },
  [GET_CLIENT_USERS_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_CLIENT_USERS_REQUEST);
      clientApi
        .getClientUsers(payload)
        .then((response) => {
          commit(GET_CLIENT_USERS_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(GET_CLIENT_USERS_ERROR);
          reject(error);
        });
    });
  },

  [PUT_USER_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(PUT_USER_REQUEST);
      clientApi
        .updateUser(payload)
        .then((response) => {
          commit(PUT_USER_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(PUT_USER_ERROR, error);
          reject(error);
        });
    });
  },
  [PUT_CLIENT_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(PUT_CLIENT_REQUEST);
      clientApi
        .updateClient(payload)
        .then((response) => {
          commit(PUT_CLIENT_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(PUT_CLIENT_ERROR, error);
          reject(error);
        });
    });
  },

  [DELETE_USER_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(DELETE_USER_REQUEST);
      clientApi
        .deleteUser(payload)
        .then((response) => {
          commit(PUT_CLIENT_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(PUT_CLIENT_ERROR, error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [ADD_CLIENT_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADD_CLIENT_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'client', response.data);
  },
  [ADD_CLIENT_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response);
  },

  [ADD_USER_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADD_USER_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'user', response.data);
  },
  [ADD_USER_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [GET_CLIENTS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_CLIENTS_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'clients', response.data);
  },
  [GET_CLIENTS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [GET_CLIENT_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_CLIENT_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'client', response.data);
  },
  [GET_CLIENT_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [GET_CLIENT_USERS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_CLIENT_USERS_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'current_client', response.data);
  },
  [GET_CLIENT_USERS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [PUT_CLIENT_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [PUT_CLIENT_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'client', response.data);
  },
  [PUT_CLIENT_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [PUT_USER_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [PUT_USER_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'user', response.data.results);
  },
  [PUT_USER_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [DELETE_USER_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [DELETE_USER_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [DELETE_USER_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
